import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'

export const headerStyle = {
    mt: pxToRem(5),
    mb: pxToRem(24),
    fontFamily: fonts.primary,
    fontWeight: '700',
    color: 'cav_light_black',
    fontSize: pxToRem(16),
    letterSpacing: pxToRem(1)
}

export const articleImage = {
    mr: pxToRem(20),
    my: 'auto',
    mx: {base: pxToRem(25), md: 0}
}

export const articleHeader = {
    fontFamily: fonts.primary,
    fontWeight: '700',
    color: 'cav_light_black',
    fontSize: pxToRem(14),
    letterSpacing: pxToRem(1),
    mb: pxToRem(15),
    lineHeight: pxToRem(20),
    textAlign: 'justify',
    _hover: {
        textDecoration: 'none'
    }
}

export const articleDate = {
    fontFamily: fonts.primary,
    color: 'cav_light_black',
    fontSize: pxToRem(12),
    letterSpacing: pxToRem(1),
    mb: pxToRem(5)
}

export const articleDescription = {
    fontFamily: fonts.primary,
    color: 'cav_light_black',
    fontSize: pxToRem(12),
    letterSpacing: pxToRem(1),
    mb: 0,
    lineHeight: pxToRem(18),
    maxHeight: {base: pxToRem(72), md: 'none'},
    overflow: {base: 'hidden', md: 'visible'},
    textAlign: 'justify'
}

export const articleMore = {
    fontFamily: fonts.primary,
    color: 'cav_red_separator',
    fontSize: pxToRem(12),
    letterSpacing: pxToRem(1),
    m: 0,
    p: 0,
    fontWeight: 500,
    _hover: {
        textDecoration: 'none'
    }
}

export const dividerStyle = {
    w: '100%',
    h: '1px',
    bg: 'cav_pdp_light_gray',
    mt: pxToRem(10),
    mb: pxToRem(20)
}
